export default "__VITE_ASSET__CSZdYcXP__"